import { tr } from "../lib/i18n";
import { contactUrl, useLicense } from "../lib/license";
import { useAuth } from "../lib/auth";

const STYLES = {
  red: { background: "#fde8e8", color: "#8a1c1c", borderBottom: "1px solid #f3b4b4" },
  yellow: { background: "#fff6d6", color: "#6b4e00", borderBottom: "1px solid #f0d98a" },
};

function pick(lic, manager) {
  if (lic.status === "suspended") return ["red", "lic.banner_suspended"];
  if (lic.status === "read_only") return ["red", "lic.banner_read_only"];
  if (lic.status === "past_due" && manager) return ["yellow", "lic.banner_past_due"];
  if (lic.cant_verify && manager) return ["yellow", "lic.banner_cant_verify"];
  return null;
}

export const LicenseBanner = () => {
  const { lic } = useLicense();
  const { user } = useAuth();
  if (!lic || lic.mode === "dev") return null;
  const manager = ["admin", "management"].includes(user?.role);
  const hit = pick(lic, manager);
  if (!hit) return null;
  const url = contactUrl(lic);
  return (
    <div role="alert" className="px-4 md:px-8 py-2.5 text-sm flex flex-wrap items-center gap-3" style={STYLES[hit[0]]} data-testid={`license-banner-${lic.cant_verify && hit[1] === "lic.banner_cant_verify" ? "cant-verify" : lic.status}`}>
      <span className="flex-1">{tr(hit[1])}</span>
      {manager && url && hit[1] !== "lic.banner_cant_verify" && (
        <a href={url} target="_blank" rel="noopener noreferrer" className="underline font-medium" data-testid="license-banner-renew">{tr("lic.upgrade_renew")}</a>
      )}
    </div>
  );
};
